module.exports = __webpack_public_path__ + "src/assets/img/trailer.0ad9c2c5.svg";